import React from 'react';
import type { GlobalAttributesT, XstyledProps } from '@elliemae/ds-props-helpers';
import {
  useGetGlobalAttributes,
  useGetXstyledProps,
  useMemoMergePropsWithDefault,
  useValidateTypescriptPropTypes,
} from '@elliemae/ds-props-helpers';
import { propTypes, defaultProps, type DSMobileBannerT } from '../propTypes.js';
import { DSMobileBannerName } from '../DSMobileBannerDefinitions.js';

interface UseMobileBannerT {
  propsWithDefault: DSMobileBannerT.InternalProps;
  globalAttributes: GlobalAttributesT;
  xstyledProps: XstyledProps;
}

export const useDSMobileBanner = (props: DSMobileBannerT.Props): UseMobileBannerT => {
  useValidateTypescriptPropTypes(props, propTypes, DSMobileBannerName);
  const propsWithDefault = useMemoMergePropsWithDefault<MobileBannerPropsT>(props, defaultProps);
  const globalAttributes = useGetGlobalAttributes(propsWithDefault);

  const xstyledProps = useGetXstyledProps(propsWithDefault);
  return React.useMemo(
    () => ({ globalAttributes, xstyledProps, propsWithDefault }),
    [globalAttributes, xstyledProps, propsWithDefault],
  );
};
